export default __webpack_public_path__ + "static/media/image-work-team-w.c86facaf.png";